"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsolationValve = void 0;
const Valve_1 = require("./Valve");
const typeName = 'IsolationValve';
class IsolationValve extends Valve_1.Valve {
    constructor(ob) {
        var _a, _b;
        super({ ...ob, type: typeName });
        this.valveState = ob.valveState || false;
        this.image = (_a = ob.image) !== null && _a !== void 0 ? _a : null;
        this.location = (_b = ob.location) !== null && _b !== void 0 ? _b : undefined;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                label: 'Name',
                name: 'name',
                description: 'Name of Valve',
            },
            state: {
                type: 'String',
                editable: true,
                label: 'Name',
                name: 'name',
                description: 'Name of Valve',
            },
            location: {
                type: 'object',
                editable: true,
                label: 'Location',
                name: 'location',
                description: 'Location of  Valve (lat/ long)',
            },
            valveState: {
                type: 'Boolean',
                editable: false,
                label: 'Active Valve',
                name: 'Active Valve',
                description: 'Is the valve active',
            },
            image: {
                type: 'String',
                editable: true,
                label: 'Image',
                name: 'image',
                description: 'Photograph of Valve',
            },
            comments: {
                type: 'String',
                editable: true,
                label: 'Comments',
                name: 'comments',
                description: 'Free text for info ',
            },
        };
    }
}
exports.IsolationValve = IsolationValve;
